<template>
  <div id="app">
    <alert />
    <router-view />
  </div>
</template>
<script>
import Alert from "./components/Alert";
import { publicPath } from "@/main";

export default {
  name: "App",
  components: {
    Alert
  },
  mounted() {
    this.changeTitle();
    this.$store.commit("account/initBrowser");
  },
  watch: {
    "$route.path"() {
      this.changeTitle();
    }
  },
  methods: {
    changeTitle() {
      const title = this.getCompanyText('company_shortname');
      document.title =
        this.$route.meta.title === undefined
          ? title
          : this.$route.meta.title + " - " + title;
    }
  },
  data() {
    return {
      publicPath: publicPath
    };
  }
};
</script>
